import React, { Component } from 'react';
import { CodeDragItemType } from 'app/area/codetable/list/constants';
import { renderCodeDragPreview } from 'app/area/codetable/list/list-items/drag-and-drop/code-drag-preview';
import { CodeDragPreviewItem } from 'app/area/codetable/list/list-items/drag-and-drop/code-drag-preview-item';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';
import { DragPromptConfirmation } from 'app/area/codetable/list/list-items/drag-and-drop/drag-prompt-confirmation';

interface CodetableListDragPreviewProps extends CodetableListComponentProps {
  wrappedComponent: React.ComponentClass<CodetableListComponentProps>;
}
export class CodetableListDragPreview extends Component<CodetableListDragPreviewProps> {
  public render() {
    const WrappedComponent = this.props.wrappedComponent;

    return <WrappedComponent {...this.props}>
      <CodeDragPreviewItem
        renderItem={renderCodeDragPreview}
        itemType={CodeDragItemType.codeTile} />
      <DragPromptConfirmation {...this.props} />
    </WrappedComponent>;
  }
}
